import {Header} from '../header'
// import {Anime} from '../anime'
import { CanvasAnimation } from '../canvasAnimation'
import { ThreeAnimation } from '../threeAnimation'

export const Layout = ({children}) => {
  return (
    <div>
      <Header/>
      {children}
      {/* <Anime/> */}
      <CanvasAnimation/>
      <ThreeAnimation/>
    </div>
  )
}